import React from 'react'
import { PRODUCT_TYPE } from 'domain/enums'
import {
  definePulsingAnimate,
  definePulsingVariant,
  getStepName,
} from 'homepage/application/leadListService'
import { object } from 'prop-types'
import { formatCpf, formatDate } from 'shared/helpers'
import {
  Accordion,
  ArrowDownIcon,
  CarIcon,
  HomeIcon,
  Pagination,
  PulsingCircle,
} from 'shared/ui'
import { AccordionContent, AccordionItem } from 'shared/ui/Accordion'
import { ProposalColumn } from 'shared/ui/ProposalsItems/ProposalColumn'
import { ProposalHeader } from 'shared/ui/ProposalsItems/ProposalHeader'
import { ContainerDetails, ContentDetails } from '../AccordionDetails'
import { ContentResumeDetail } from '../AccordionDetails/ContentResumeDetail'
import { CardFeed, CardResumeFeed } from '../CardFeed'
import { Step, StepWrapper, LeadsListWrapper } from '../Home.styles'
import {
  AccordionHeaderStyled,
  ArrowIcon,
  ContainerIconWarranty,
} from './styles'
import { LeadsListEmpty } from 'homepage/presentation/components/LeadsListEmpty'
import { AgentIndicateEmpty } from 'homepage/presentation/components/AgentIndicateEmpty'

const propTypes = {
  leads: object.isRequired,
}

const LeadsList = ({
  leads,
  leadDetail,
  page,
  changePage,
  limit,
  hasFilter,
}) => {
  return (
    <>
      {leads?.items && leads?.items.length > 0 && (
        <>
          <LeadsListWrapper data-testid="leads-container">
            <ProposalHeader
              testId="leads-proposals-head"
              headings={[
                {
                  id: 'warranty',
                  title: '',
                },
                {
                  id: 'name',
                  title: 'Nome',
                },
                {
                  id: 'cpf',
                  title: 'CPF',
                },
                {
                  id: 'step',
                  title: 'Etapa',
                },
                {
                  id: 'date',
                  title: 'Data de criação',
                },
              ]}
            />

            <div>
              <Accordion>
                {leads?.items?.map(row => (
                  <AccordionItem testId={`lead-${row.id}`} key={row.id}>
                    <AccordionHeaderStyled
                      id={row.id}
                      onClick={() => leadDetail.handleProposalDetail(row.id)}
                    >
                      <ProposalColumn
                        testId={`lead-product-${row.id}`}
                        style={{ gridArea: 'warranty' }}
                      >
                        <ContainerIconWarranty className="warrantyIcon">
                          {PRODUCT_TYPE[row.productType] ===
                          'Veículo em garantia' ? (
                            <CarIcon />
                          ) : (
                            <HomeIcon />
                          )}
                        </ContainerIconWarranty>
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-fullname-${row.id}`}
                        style={{ gridArea: 'name' }}
                      >
                        {row.borrower.fullName}
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-cpf-${row.id}`}
                        style={{ gridArea: 'cpf' }}
                      >
                        {formatCpf(row.borrower.cpf)}
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-step-${row.id}`}
                        style={{ gridArea: 'step' }}
                      >
                        <StepWrapper>
                          <PulsingCircle
                            variant={definePulsingVariant({
                              currentStep: row.currentStep,
                            })}
                            animate={definePulsingAnimate({
                              currentStep: row.currentStep,
                              pendingAction: row.pendingAction,
                            })}
                            size={
                              definePulsingAnimate({
                                currentStep: row.currentStep,
                                pendingAction: row.pendingAction,
                              })
                                ? 6
                                : 16
                            }
                          />
                          <Step>
                            {getStepName({ currentStep: row.currentStep })}
                          </Step>
                        </StepWrapper>
                      </ProposalColumn>
                      <ProposalColumn
                        testId={`lead-dateCreated-${row.id}`}
                        style={{ gridArea: 'date' }}
                      >
                        {formatDate(row.createdAt)}
                      </ProposalColumn>
                      <ArrowIcon>
                        <ArrowDownIcon />
                      </ArrowIcon>
                    </AccordionHeaderStyled>

                    <AccordionContent productType={row.productType}>
                      <ContainerDetails>
                        <ContentDetails>
                          <ContentResumeDetail
                            id={row.id}
                            loading={leadDetail.loading}
                            proposalDetail={leadDetail.proposalDetail}
                          />
                        </ContentDetails>
                        <CardFeed loading={leadDetail.loading}>
                          <CardResumeFeed
                            lead={leadDetail.lead}
                            documentsRequired={leadDetail.documentsRequired}
                          />
                        </CardFeed>
                      </ContainerDetails>
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </LeadsListWrapper>
          <Pagination
            testId="leads-pagination"
            currentPage={page}
            onChangePage={changePage}
            totalItems={leads?.cursors?.metadata?.total}
            limit={limit}
            totalVisibleItems={5}
          />
        </>
      )}
      {hasFilter && leads?.items && leads.items.length === 0 && (
        <LeadsListEmpty />
      )}
      {!hasFilter && leads?.items && leads.items.length === 0 && (
        <AgentIndicateEmpty />
      )}
    </>
  )
}

LeadsList.propTypes = propTypes

export { LeadsList }
